export default function animateLeopardGirl(element) {
    const image = document.querySelector('[data-leopard-girl-image]');
    let elementTop;
    let elementHeight;
    let frameHeight;
    let offsetPaddingTop;
    let viewportHeight;
    let ratio;

    if (element) {
        initialise();

        window.addEventListener('scroll', startAnimation);
        window.addEventListener('resize', initialise);
        image.addEventListener('load', initialise);
    }

    function initialise() {
        elementTop = getElementTop(element);
        elementHeight = element.clientHeight;
        frameHeight = elementHeight * 0.57;
        offsetPaddingTop = elementHeight * 0.13;
        viewportHeight = window.innerHeight;
        ratio = frameHeight / viewportHeight;

        startAnimation();
    }

    function startAnimation() {
        if (isElementInViewport()) {
            let containerOffsetTop = element.getBoundingClientRect().top;
            let distance = containerOffsetTop * ratio - offsetPaddingTop;

            if (distance > 0) {
                image.style.top = distance + 'px';
            } else {
                image.style.top = 0;
            }
        }
    }

    function isElementInViewport() {
        return (elementTop <= (window.pageYOffset + viewportHeight) &&
            (elementTop + elementHeight) >= window.pageYOffset);
    }

    function getElementTop(el) {
        let top = el.offsetTop;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
        }

        return top;
    }
}



/** WEBPACK FOOTER **
 ** ./js/marketing/components/leopard-girl.js
 **/